module.exports = __webpack_public_path__ + "img/headphone-man.09e48082.png";